import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor,

    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { STORAGE_CUSTOMER, STORAGE_CUSTOMER_JWT, STORAGE_REFRESH_CUSTOMER_DATE } from '../constants';

  @Injectable()
  export class UnauthorizedInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(
      request: HttpRequest<any>,
      next: HttpHandler,
    ): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => null,
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                if (localStorage.getItem(STORAGE_CUSTOMER)) {
                  // JWT Expired
                  localStorage.removeItem(STORAGE_CUSTOMER_JWT)
                  localStorage.removeItem(STORAGE_CUSTOMER)
                  localStorage.removeItem(STORAGE_REFRESH_CUSTOMER_DATE)
                  // Unauthorized
                  this.router.navigate(['/login']);
                }
              } else if (err.status == 500 && err.error && ['jwt malformed', 'jwt expired', 'invalid signature', 'invalid token'].includes(err.error.message)) {
                // JWT Expired
                localStorage.removeItem(STORAGE_CUSTOMER_JWT)
                localStorage.removeItem(STORAGE_CUSTOMER)
                localStorage.removeItem(STORAGE_REFRESH_CUSTOMER_DATE)
              } else {
                console.error(err)
              }
            }
          },
        ),
      );
    }
  }
